import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import { useTranslation } from 'react-i18next';

const AutoCompleteInput = ({
  label,
  onSearch,
  placeholder,
  onSelect,
  defaultValue,
  defaultOptions = [],
  isMulti = false,
  defaultOptionsValue = null,
  value = null,
  isClearable = true
}) => {
  const { t } = useTranslation(['backoffice']);

  return (
    <div className="mt-3">
      {label && <Form.Label className="text-light">{label}</Form.Label>}
      <AsyncSelect
        cacheOptions
        defaultOptions={defaultOptions}
        defaultValue={defaultValue}
        loadOptions={onSearch}
        onChange={onSelect}
        placeholder={placeholder}
        isClearable={isClearable}
        classNamePrefix="search-autocomplete"
        isMulti={isMulti}
        noOptionsMessage={() => t('typeStartSearch')} 
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: 'neutral60',
          },
        })}
        value={value || defaultOptionsValue || defaultValue}
      />
    </div>
  );
};

AutoCompleteInput.propTypes = {
  items: PropTypes.array,
  label: PropTypes.string,
  onSearch: PropTypes.func,
  onSelect: PropTypes.func,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.any,
  isClearable: PropTypes.bool
};

export default AutoCompleteInput;
